import { Button } from '@app/components/various/Button';
import { CameraSlash } from '@app/components/various/Icons';
import { useTranslation } from 'react-i18next';

import styles from '../ScannerContent.module.scss';

interface Props {
  hasRequestedPermissions: boolean;
  requestPermissions: () => void;
}

export const NoPermissions = ({ hasRequestedPermissions, requestPermissions }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <div className={styles.message}>
      <CameraSlash className="size-12 text-neutral-60" />
      <Button onClick={requestPermissions}>{hasRequestedPermissions ? t('common:try_again') : t('common:allow_camera')}</Button>
    </div>
  );
};
